import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { IBranchWiseIncentive } from "./BranchIncentive";
import { format } from "date-fns";
import { Fetch } from "../../shared/Fetch";
import { ILogin } from "../../models/Login";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { GenerateInvoice } from "./GenerateInvoice";
import { EmptyFilter, Filter } from "./Filter";
import { Accordion, AccordionTab } from "primereact/accordion";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface Iprops {
    toast: any
}

export const Table = (props: Iprops) => {
    const [selectedBranchWiseIncentive, setSelectedBranchWiseIncentive] = useState<IBranchWiseIncentive[]>([]);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IBranchWiseIncentive>, loading: boolean });
    const [modal, setModal] = useState({ open: false, singleData: [] } as { open: boolean, singleData: IBranchWiseIncentive[] });
    const [incentiveFilter, setIncentiveFilter] = useState(EmptyFilter);
    const [isSales, setIsSales] = useState(true);
    const [reload, setReload] = useState(false);
    const dt: any = useRef<any>(null);
    const dt2: any = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const header = () => {
        return <p></p>
    }

    const exportCSV = () => {
        dt2.current.exportCSV();
    };

    const generateBranchInvoice = async () => {
        if (incentiveFilter.branch !== undefined && incentiveFilter.branch !== null && incentiveFilter.branch > 0) {
            const respone = await Fetch("InvoiceTracking/invoiceGeneratedBranchWiseIncentiveCalculation", "PUT", selectedBranchWiseIncentive, `BranchID=${incentiveFilter.branch}&UserType=${isSales === true ? 2 : 3}`, props.toast);
            if (respone) {
                exportCSV();
                setSelectedBranchWiseIncentive([]);
                loadTableData();
            }
        } else props.toast.current.show({ severity: 'error', detail: 'Please Select A Branch In Filter', life: 3000 });
    }

    const leftToolbarTemplate = () => {
        return (
            <div className="flex gap-2">
                <Button icon="pi pi-refresh" className="p-button-primary" onClick={() => loadTableData()} />
                <Button label="Sales" className={isSales === true ? "p-button-primary" : "p-button-outlined"} onClick={() => setIsSales(true)} />
                <Button label="Recruiter" className={isSales === false ? "p-button-primary" : "p-button-outlined"} onClick={() => setIsSales(false)} />
            </div>
        );
    }

    const rightToolbarTemplate = () => {
        return (
            <div className="flex gap-2">
                {selectedBranchWiseIncentive.length > 0 && <Button icon="pi pi-upload" label="Generate Invoice" className="p-button-primary" onClick={() => generateBranchInvoice()} />}
            </div>
        );
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const userTypeQuery = isSales ? "&userType=2" : "&userType=3";
        const response = await Fetch("InvoiceTracking/getBranchWiseIncentiveCalculation", "GET", null, `filter=${encodeURIComponent(JSON.stringify(incentiveFilter))}` + userTypeQuery, props.toast);
        if (response) {
            const data: Array<IBranchWiseIncentive> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    useEffect(() => {
        loadTableData();
    }, [incentiveFilter, reload, isSales]);

    const DateFormat = loginObj?.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter incentiveFilter={incentiveFilter} setIncentiveFilter={setIncentiveFilter} toast={props.toast} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                emptyMessage="No Branches found."
                header={header}
                loading={tableData.loading}
                selectionMode={'checkbox'}
                selection={selectedBranchWiseIncentive}
                onSelectionChange={(e) => {
                    const value = e.value as IBranchWiseIncentive[];
                    setSelectedBranchWiseIncentive(value);
                }}
            >
                {_roles.includes(1) && (incentiveFilter.branch !== undefined && incentiveFilter.branch !== null && incentiveFilter.branch > 0) && <Column style={{ minWidth: '3rem', maxWidth: '3rem' }} selectionMode="multiple" />}
                <Column field="invoiceNO" header="#Invoice" style={{ minWidth: '8rem', maxWidth: '8rem' }} />
                {/* <Column field="fromDate" header="From Date" style={{ minWidth: '8rem', maxWidth: '8rem' }} body={(rowData: IBranchWiseIncentive) => {
                    let date;
                    if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<p>{date}</p>);
                }} /> */}
                <Column field="fromDate" header="From Date" style={{ minWidth: '8rem', maxWidth: '8rem' }} body={(rowData: any) => safeFormatDate(rowData.fromDate, "dd/MM/yyyy", DateFormat)} />
                {/* <Column field="toDate" header="To Date" style={{ minWidth: '8rem', maxWidth: '8rem' }} body={(rowData: IBranchWiseIncentive) => {
                    let date;
                    if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<p>{date}</p>);
                }} /> */}
                <Column field="toDate" header="To Date" style={{ minWidth: '8rem', maxWidth: '8rem' }} body={(rowData: any) => safeFormatDate(rowData.toDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="consultant_Name" style={{ minWidth: '8rem', maxWidth: '8rem' }} header="Consultant Name" />
                <Column field="vendor_Company_Name" style={{ minWidth: '9rem', maxWidth: '9rem' }} header="Client Company Name" />
                <Column field="invoiceHours" header="Inv Hrs" />
                <Column field="calculatedAmount" header="Inv Amnt ($)" body={(rowData) => <p>{rowData.calculatedAmount}</p>} />
                {/* <Column field="userType" header="User Type" /> */}
                <Column field="company_Name" header="Company Name" />
                <Column field="branchName" header="Branch Name" />
                <Column field="userBranchPercentage" header="Branch (%)" body={(rowData) => <p>{rowData.userBranchPercentage}</p>} />
                <Column field="userBranchAmount" header="Branch Inv Amnt ($)" body={(rowData) => <p>{Number(rowData.userBranchAmount).toFixed()}</p>} />
            </DataTable>

            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px", display: "none" }}
                ref={dt2}
                value={selectedBranchWiseIncentive}
            >
                <Column field="id" header="ID" style={{ minWidth: '8rem', maxWidth: '8rem' }} />
                <Column field="invoiceNO" header="#Invoice" style={{ minWidth: '8rem', maxWidth: '8rem' }} />
                <Column field="fromDate" header="From Date" style={{ minWidth: '8rem', maxWidth: '8rem' }} body={(rowData: IBranchWiseIncentive) => {
                    let date;
                    if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<p>{date}</p>);
                }} />
                <Column field="toDate" header="To Date" style={{ minWidth: '8rem', maxWidth: '8rem' }} body={(rowData: IBranchWiseIncentive) => {
                    let date;
                    if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<p>{date}</p>);
                }} />
                <Column field="consultant_Name" style={{ minWidth: '8rem', maxWidth: '8rem' }} header="Consultant Name" />
                <Column field="vendor_Company_Name" style={{ minWidth: '9rem', maxWidth: '9rem' }} header="Client Company Name" />
                <Column field="invoiceHours" header="Inv Hrs" />
                <Column field="calculatedAmount" header="Inv Amnt" />
                <Column field="userType" header="User Type" />
                <Column field="company_Name" header="Company Name" />
                <Column field="branchName" header="Branch Name" />
                <Column field="userBranchPercentage" header="Branch (%)" body={(rowData) => <p>{rowData.userBranchPercentage}</p>} />
                <Column field="userBranchAmount" header="Branch Amount ($)" body={(rowData) => <p>{Number(rowData.userBranchAmount).toFixed()}</p>} />
            </DataTable>
            <GenerateInvoice setModal={setModal} modal={modal} toast={props.toast} reload={reload} setReload={setReload} />
        </>
    );
}